import Cookie from '../node_modules/vue-cookies/vue-cookies'
/**
 * token的名字
 */
const TOKEN_KEY = 'token'
export default {
  /**
   * 获取token
   */
  getToken() {
    if (
      Cookie.get(TOKEN_KEY) !== null &&
      typeof Cookie.get(TOKEN_KEY) !== 'undefined' &&
      Cookie.get(TOKEN_KEY) !== ''
    ) {
      return Cookie.get(TOKEN_KEY)
    }
    // else if (localStorage.getItem(TOKEN_KEY) !== null && typeof (localStorage.getItem(TOKEN_KEY)) !== 'undefined' && localStorage.getItem(TOKEN_KEY) !== '') {
    //   return localStorage.getItem(TOKEN_KEY);
    // }
    else {
      return Cookie.get(TOKEN_KEY)
    }
  },
  /**
   * 设置token
   * @param {String} token token内容
   */
  setToken(token) {
    // localStorage.setItem(TOKEN_KEY, token)
    Cookie.set(TOKEN_KEY, token)
  },
  /**
   * 清除token
   */
  removeToken() {
    Cookie.remove(TOKEN_KEY)
    // localStorage.removeItem(TOKEN_KEY);
  },
  /**
   * 设置cookie
   * @param {String} name cookie名字
   * @param {String} value cookie内容
   */
  setCookie(name, value) {
    // localStorage.setItem(name, value)
    Cookie.set(name, value)
  },
  /**
   * 获取cookie
   * @param {String} name cookie名字
   */
  getCookie(name) {
    if (
      Cookie.get(name) !== null &&
      Cookie.get(name) !== 'undefined' &&
      Cookie.get(name) !== ''
    ) {
      return Cookie.get(name)
    }
    // else if (localStorage.getItem(name) !== null && localStorage.getItem(name) !== 'undefined' && localStorage.getItem(name) !== '') {
    //   return localStorage.getItem(name);
    // }
    else {
      return Cookie.get(name)
    }
  },
  /**
   * 清除cookie
   * @param {String} name
   */
  removeCookie(name) {
    Cookie.remove(name)
    // localStorage.removeItem(name);
  },
}
